import generateQAAutomationIDs from '../../global/_generate-qa-automation-ids'

class HomepageHero extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const elementsToQuery = [
      { el: 'h1', name: 'HomepageHero-header' },
      { el: 'p', name: 'HomepageHero-content' },
      { el: 'a', name: 'HomepageHero-link' },
      { el: 'button', name: 'HomepageHero-Find-A-Mutual-Fund' },
    ]

    generateQAAutomationIDs(this, elementsToQuery)
  }
}

customElements.define('homepage-hero', HomepageHero)
